export default __webpack_public_path__ + "55d43fc31513226ce5c1bb9b73f76015.webp";